/* A component that is used to delete a form. */
import axios from "axios"
import moment from "moment"
import React, { Component } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"
import AxiosConfig from "src/utilities/AxiosConfig"
import stateMutator from "../Utils/StateMutator"
import DynamicFormTypes from "../Types/DynamicFormsTypes"
import snackBar from "src/utilities/snackBar/SnackBar"
import "./DeleteDynamicForm.css"

interface Props {
    // formTypes: Array<{ CustomFormTypeId: number, Type: string }>
    manageParentState: Function
    callParentFunction: Function
    form: DynamicFormTypes
    userId: string | number
}

interface State {
    busy: boolean
}

class DeleteDynamicForm extends Component<Props, State> {

    state = {
        busy: false
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    /* Deleting the form. */
    deleteForm = () => {
        this.manageState([{ key: "busy" }])
        let rb = this.props.form
        rb.DeletedBy = this.props.userId
        rb.DeletedDate = moment(Date.now().valueOf()).format()
        axios.post(process.env.REACT_APP_API_URL + "/api/company/AddEditDynamicForm", rb, AxiosConfig.configValue("min"))
            .then((res: any) => {
                this.props.manageParentState([{ key: "formToDelete", value: null }])
                this.props.callParentFunction("getDynamicForms", false, true)
            }).catch((err: any) => {
                //console.log("df_ Dyanamic forms err", err)
                snackBar({ text: "Error deleteing form", type: "error", timeout: 3000 })
            })
    }

    render() {

        const props = this.props
        const state = this.state

        return (
            <div className="DeleteDynamicForm">
                <Modal
                    id="delete-dynamic-form-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="DeleteDynamicFormModalHeader">
                            {!state.busy && <p>Delete <span>{`${props.form.Name}`}</span>?</p>}
                            {state.busy && <p>Deleting <span>{`${props.form.Name}`}</span>...</p>}
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="DeleteDynamicFormModalFooter">
                            {state.busy && <div className="DeleteDynamicFormModalFooterBusy">
                                <Spinner animation="border" />
                            </div>}
                            {!state.busy && <div className="DeleteDynamicFormModalFooterNotBusy">
                                <Button variant="secondary" onClick={() => props.manageParentState([{ key: "formToDelete" }])}>Cancel</Button>
                                <Button variant="danger" onClick={() => this.deleteForm()}>Delete</Button>
                            </div>}
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default DeleteDynamicForm